import { FlatGroundStructure } from "../../site/flat-ground-structure";
import { FlatGround } from "../../site/flatground/earthbrain-flatground";
import { FlatgroundConstructionHandler } from "./flatground-construction-handler";
import { FlatGroundEditHandler } from "./flatground-edit-handler";
import { ConstructionState } from "../../site/trench/earthbrain-trench";
import { getDefaultCutFlatGroundSettings, getDefaultEmbankmentFlatGroundSettings, getFlatGroundCommonSettings, } from "../../settings/earthbrain-site-settings";
import { VolumeCalculationUtils } from "../../utilities/volume-calculation-utils";
export class FlatGroundHandler {
    _flatGroundConstructionHandler;
    _flatGroundEditHandler;
    _site;
    _cesiumViewer;
    _preview;
    get editHandler() {
        return this._flatGroundEditHandler;
    }
    constructor(args, cesiumViewer) {
        this._site = args.site;
        this._preview = args.preview;
        this._cesiumViewer = cesiumViewer;
        this._flatGroundConstructionHandler = new FlatgroundConstructionHandler(args, cesiumViewer);
        this._flatGroundEditHandler = new FlatGroundEditHandler(args, cesiumViewer);
    }
    //loaders
    async loadFlatGroundInfo(data) {
        const flatGround = await FlatGround.fromJSON(data, this._cesiumViewer, this._preview);
        this._site.addFlatGround(flatGround);
        this._site.structureManager.addStructure(flatGround.id, new FlatGroundStructure(flatGround));
        return flatGround;
    }
    //construction
    startFlatGroundConstruction(callback, associatedTerrain, associatedRubbingDestination) {
        this._flatGroundConstructionHandler.start(callback, associatedTerrain, associatedRubbingDestination);
    }
    finishFlatGroundConstruction() {
        this._flatGroundConstructionHandler.finish();
    }
    cancelFlatgroundConstruction() {
        this._flatGroundConstructionHandler.cancel();
    }
    checkFlatGroundUnderCreation() {
        return (this._flatGroundConstructionHandler.flatGround &&
            this._flatGroundConstructionHandler.flatGround.constructionState ===
                ConstructionState.UNDER_CONSTRUCTION);
    }
    //edit
    startFlatGroundEdit(flatGround, callback) {
        this._flatGroundEditHandler.start(flatGround, callback);
    }
    finishFlatGroundEdit() {
        this._flatGroundEditHandler.end();
    }
    cancelFlatGroundEdit() {
        this._flatGroundEditHandler.cancel();
    }
    async updateFlatGroundSettings(flatGroundID, settings) {
        const flatGround = this._site.getFlatGround(flatGroundID);
        if (!flatGround) {
            return;
        }
        const embankmentSettings = Object.assign(getDefaultEmbankmentFlatGroundSettings(), settings.embankmentSettings);
        const cutSettings = Object.assign(getDefaultCutFlatGroundSettings(), settings.cutSettings);
        const commonSettings = Object.assign(getFlatGroundCommonSettings(), settings.commonSettings);
        await flatGround.updateSettings({
            commonSettings,
            embankmentSettings: embankmentSettings,
            cutSettings: cutSettings,
        });
    }
    /**
     * This function will check Flat Ground in _flatGroundMap and calculate volume of particular Flat Ground
     * @param flatGroundID ID of Flat Ground whose volume to calculate
     * @returns Fill and Cut Volume calculated based on heightmap
     */
    async volumeCalculationForFlatGround(flatGroundID) {
        const flatGround = this._site.getFlatGround(flatGroundID);
        if (!flatGround) {
            throw new Error(`Flatground not found with ID ${flatGroundID}`);
        }
        const data = this.getVolumeCalculationDataForFlatGround(flatGround);
        if (data.sourceHeightMap === undefined) {
            throw new Error(`Height Map not found for Terrain ${flatGround.associatedTerrain.id}`);
        }
        return await VolumeCalculationUtils.calculateVolume(data);
    }
    getVolumeCalculationDataForFlatGround(flatGround) {
        const heightmap = flatGround.associatedTerrain.heightMap;
        return {
            targetHeightMap: flatGround.heightMap.getObject(),
            sourceHeightMap: heightmap.getObject(),
        };
    }
    surfaceAreaCalculationForFlatGround(flatGroundID) {
        const flatGround = this._site.getFlatGround(flatGroundID);
        const flatGroundCenterGeometry = flatGround.getCenterGeometry();
        const totalSurfaceArea = flatGround.computeSurfaceArea(flatGroundCenterGeometry);
        return totalSurfaceArea;
    }
    getMaxHeightOfFlatGroundCtrlPts(flatGroundID) {
        const flatGround = this._site.getFlatGround(flatGroundID);
        return flatGround.getCalcMaxControlPtHeight();
    }
    async setFlatGroundPointsUniformHeight(id, height) {
        await this._flatGroundEditHandler.setFlatGroundPointsUniformHeight(id, height);
    }
}
//# sourceMappingURL=flatground-handler.js.map